import { tr } from "date-fns/locale"
import { FieldViewModel } from "../exports"
import { ISeedRatePlan } from "../types"
import { isCroppingInPlan, isFieldInPlan } from "../utils"
import { DatalayersMap } from "@omnia/shared/layers/datalayersMap"

export class SeedsMap extends DatalayersMap {

    private _plan: ISeedRatePlan

    private _cropId: number
    private _varietyId: number

    setupLayers() {
        super.setupLayers()
        this.croppingLayer.showVarietyNames = true
    }

    get currentPlan() {
        return this._plan
    }

    set currentPlan(plan) {
        this._plan = plan
        this._varietyId = plan?.VarietyId
        this.setFields()
    }

    get currentCropId() {
        return this._cropId
    }

    get currentVarietyId() {
        return this._varietyId
    }

    setCurrentCropAndVariety(cropId: number, varietyId: number) {
        this._cropId = cropId
        this._varietyId = varietyId
        this.setFields()
    }

    protected getFilters() {

        const filters = super.getFilters()

        const showCropping = (c: FieldViewModel) => {

            if (isCroppingInPlan(c, this._plan)) return true
            if (filters.cropping(c)) return true

            return c.currentYear
                && this._cropId
                && (c.cropId == this._cropId)
                && ((!this._varietyId) || (c.varietyId == this._varietyId))

        }

        const showField = (f: FieldViewModel) => {
            return f.croppings.some(c => c.currentYear && showCropping(c)) || isFieldInPlan(f, this._plan) || filters.fields(f)
        }

        return {
            fields: showField,
            cropping: showCropping
        }

    }

}
